module.exports = __webpack_public_path__ + "static/media/InternBanner.1557fa22.png";